export interface KaratRow {
    karat?: number;
    grams?: number;
    adjust?: number;
}

export interface CalculationParams {
    rows: KaratRow[];
    afterMass?: number;
    afterKarat?: number;
    targetKarat?: number;
    addKarat?: number;
}

export interface CalculationResult {
    totalMass: number;
    total24: number;
    avgKarat: number;
    dupaTopitContinut: number;
    pierdereGr: number;
    pierdereProc: number;
    pierdereProcTotal: number;
    gramsToAdd: number;
    finalMass: number;
    finalPure: number;
}

function calculateKarat(params: CalculationParams): CalculationResult {
    const { rows, afterMass, afterKarat, targetKarat, addKarat } = params;

    const totalMass = rows.reduce((sum, r) => sum + (r.grams ?? 0) + (r.adjust ?? 0), 0);

    const total24 = rows.reduce(
        (sum, r) => sum + (((r.grams ?? 0) + (r.adjust ?? 0)) * (r.karat ?? 0)) / 999.9,
        0,
    );

    const avgKarat = totalMass ? (total24 / totalMass) * 999.9 : 0;

    const dupaTopitContinut =
        afterMass != null && afterKarat != null ? (afterMass * afterKarat) / 999.9 : 0;

    const pierdereGr = afterMass ? totalMass - afterMass : 0;
    const pierdereProc = afterMass ? 100 - (100 * afterMass) / totalMass : 0;
    const pierdereProcTotal = dupaTopitContinut ? 100 - (100 * dupaTopitContinut) / total24 : 0;

    const gramsToAdd =
        totalMass && targetKarat && addKarat && addKarat !== targetKarat
            ? (totalMass * (targetKarat - avgKarat)) / (addKarat - targetKarat)
            : 0;

    const finalMass = totalMass + gramsToAdd;
    const finalPure = finalMass && targetKarat ? (finalMass * targetKarat) / 999.9 : 0;

    return {
        totalMass,
        total24,
        avgKarat,
        dupaTopitContinut,
        pierdereGr,
        pierdereProc,
        pierdereProcTotal,
        gramsToAdd,
        finalMass,
        finalPure,
    };
}

export default calculateKarat;
